import GridToolbarContainer from '@/global/components/DataGrid/components/CustomGridToolBar/Container'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide'
import { transacoesCliente } from 'service/api'
import { useStore } from 'store'
import { TransacaoButton } from './TransacoesButton'

const columns: GridColDefPro[] = [
    {
        field: 'subscriptionMyId',
        headerName: 'Contrato',
        width: 85,
        renderCell: ({ value }) => (
            <span title={value}>{value?.split('-')?.at(0)}</span>
        ),
    },
    {
        field: 'galaxPayId',
        headerName: 'Código',
        width: 70,
    },
    {
        field: 'CreditCard',
        headerName: 'Método de pagamento',
        width: 180,
        valueGetter: params => {
            if (params.row.CreditCard) {
                const bandeiraCartao =
                    params.row.CreditCard.Card?.Brand?.name ?? ''
                const ultimosNumeros =
                    params.row.CreditCard.Card?.number.slice(-4) ?? ''

                return `${bandeiraCartao} **** **** ${ultimosNumeros}`
            }
            if (params.row.Boleto) return 'Boleto'
            return 'PIX'
        },
    },
    {
        field: 'payday',
        headerName: 'Vencimento',
        width: 110,
        valueFormatter: params => {
            return dayjs(params.value).format('DD/MM/YYYY')
        },
    },
    {
        field: 'value',
        headerName: 'Valor',
        width: 110,
        valueFormatter: params => {
            const value = (params.value as number) / 100

            return value.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            })
        },
    },
    {
        field: 'statusDescription',
        headerName: 'Status',
        minWidth: 180,
    },
    {
        field: 'createdAt',
        headerName: 'Gerado em',
        width: 160,
        valueFormatter: params =>
            dayjs(params.value as string).format('DD/MM/YYYY HH:mm:ss'),
    },
    {
        field: 'additionalInfo',
        headerName: 'Informações adicionais',
        minWidth: 80,
        flex: 1,
    },
    {
        ...optionsColumn,
        field: '__opcoes',
        renderCell: TransacaoButton,
    },
]

export default function DataGridTransacoes() {
    const cliente = useStore(state => state.customer)

    const { data: transacoes, isLoading } = transacoesCliente.useFetch({
        queryParams: { clienteId: cliente?.id },
        enabled: !!cliente?.id,
    })

    return (
        <div className="flex h-96 w-full shrink-0 flex-col gap-1 md:h-auto md:min-h-0 md:flex-1 md:shrink">
            <ContentGuide.DataGrid
                slots={{
                    Toolbar: () => (
                        <GridToolbarContainer className="flex w-full select-none justify-between text-base font-semibold uppercase tracking-wide min-h-0 py-2">
                            Histórico de pagamentos
                        </GridToolbarContainer>
                    ),
                }}
                loading={isLoading}
                columns={columns}
                rows={transacoes?.map((t, id) => ({
                    id,
                    ...t,
                }))}
                hideFooter
                ToolbarProps={{ hideToolbar: true }}
                headerHeight={40}
                density="compact"
            />
        </div>
    )
}
